<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

import logoPlayground from '@/assets/logo-black.svg';
import logoSystra from '@/assets/logo-knower-black.svg';
import logoSystraWhite from '@/assets/logo-knower-white.svg';
import logoPlaygroundWhite from '@/assets/logo-white.svg';
import { useAuthStore } from '@/stores/auth';
import { useThemeStore } from '@/stores/theme';

const props = defineProps<{
    isSidebarOpen: boolean;
}>();

const auth = useAuthStore();
const themeStore = useThemeStore();

const isSystra = computed(() => !auth.isDescopeEnabled);

const logoSrc = computed(() => {
    if (isSystra.value) {
        return themeStore.isDark ? logoSystraWhite : logoSystra;
    }
    return themeStore.isDark ? logoPlaygroundWhite : logoPlayground;
});

const logoAlt = computed(() => (isSystra.value ? 'Knower' : 'Playground'));
</script>

<template>
    <RouterLink to="/">
        <div class="flex items-center gap-2">
            <img
                :alt="logoAlt"
                :src="logoSrc"
                :class="[
                    isSystra
                        ? props.isSidebarOpen
                            ? 'h-7'
                            : 'h-6'
                        : props.isSidebarOpen
                          ? 'h-6'
                          : 'h-[1.05rem]'
                ]"
                decoding="async"
                loading="eager"
            />
            <span
                class="text-2xl font-spartan pt-1 font-semibold whitespace-nowrap transition-opacity duration-300"
                :class="props.isSidebarOpen ? 'opacity-100' : 'opacity-0'"
                >{{ logoAlt }}</span
            >
        </div>
    </RouterLink>
</template>
